import React from 'react';
import { Popover, Table, Tag } from 'antd';
import moment from 'moment';
import util from '@util/index';

const TableBase = ({ detail }) => {
  const { type } = detail;
  const data = [
    {
      ...detail,
    },
  ];

  const getColumns = () => {
    const typeFont = ['押金', '工位收入', '地址收入'];
    const renderMoney = (key, title, width) => {
      return {
        title,
        dataIndex: key,
        width: width || 120,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      };
    };

    const renderDate = (key, title) => {
      return {
        title,
        dataIndex: key,
        width: 120,
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : null}</span>
        ),
      };
    };

    const columns = [
      {
        title: '账单基本情况',
        children: [
          {
            title: '账单编号',
            dataIndex: 'payableNo',
            width: 200,
            render: (text, record) => {
              const content = (
                <div>
                  <p>时间:{moment(record.sleepDate).format('YYYY-MM-DD')}</p>
                  <p>操作人员:{record.sleepUser}</p>
                  <p>原因:{record.sleepRemark}</p>
                </div>
              );
              return (
                <div>
                  {record.sleepStatus === 1 ? (
                    <Popover content={content}>
                      <Tag color="gray">休眠</Tag>
                    </Popover>
                  ) : (
                    ''
                  )}
                  {text}
                </div>
              );
            },
          },
          {
            title: '企业名称',
            dataIndex: 'custom',
            width: 150,
          },
          {
            title: '对应租期',
            dataIndex: 'beginDate',
            width: 220,
            render: (text, record) =>
              record.beginDate && record.endDate ? (
                <span>
                  {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
                  {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
                </span>
              ) : null,
          },
          {
            title: '收入类型',
            dataIndex: 'type',
            width: 100,
            render: text => <span>{typeFont[text]}</span>,
          },
        ],
      },
      {
        title: '款项情况',
        children: [
          renderMoney('initialPrice', '初始合同款'),
          renderMoney('price', '待收款'),
          renderMoney('confirm', '已收款'),
          renderMoney('obsolete', '作废款'),
        ],
      },
      type === 0
        ? {
            title: '押金',
            children: [
              renderMoney('deposit', '押金'),
              renderMoney('liquidate', '押金转违约金', 160),
              renderMoney('oldTurn', '到期押金（被结转）', 180),
            ],
          }
        : renderMoney('oldTurn', '被转结服务费'),
      {
        title: '支付情况',
        children: [
          renderMoney('shouldMatchTheFlow', '应匹配流水'),
          renderMoney('actualMatchTheFlow', '实匹配流水'),
        ],
      },
      {
        title: '款项状态',
        dataIndex: 'payStatus',
        width: 100,
        render: (text, record) => {
          let statusFont = '';
          if (record.price > 0) {
            if (record.price < record.initialPrice) {
              statusFont = '部分匹配';
            } else {
              statusFont = '没有匹配';
            }
          } else {
            statusFont = '完成匹配';
          }
          return <span>{statusFont}</span>;
        },
      },
      renderDate('date', '应收日期'),
      renderDate('confirmDate', '实收日期'),
      {
        title: '合同到期日期',
        dataIndex: 'termDate',
        width: 150,
        render: (text, record) => {
          const date = record.termDate || record.bussinessEndDate;
          return <span>{date ? moment.unix(date / 1000).format('YYYY-MM-DD') : null}</span>;
        },
      },
    ];
    return columns.filter(item => item);
  };

  return (
    <Table
      bordered
      columns={getColumns()}
      dataSource={data}
      pagination={false}
      rowKey="index"
      scroll={{ x: type === 0 ? 2290 : 1830 }}
    />
  );
};

export default TableBase;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TableBase.js